<app-kontable
        id="dt_application"
        title="{{ 'applicationList.sectionTitle' | translate }}"
        [columns]="['id', 'order_index', 'name', 'descr']"
        [titles]="['common.id', 'common.order_index', 'common.name', 'common.description']"
        [source]="applications"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showInfoButton]="false"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)">
        <!-- [additionalRowCommands]="customRow" -->
        <!--<ng-template #customRow data-testid="customRow" let-row>
          <p-button label="" pTooltip="{{'common.manageAssociations' | translate}}" icon="fa fa-bars" styleClass="ui-button-info" (onClick)="openAssociate(row)"></p-button>
        </ng-template>-->
</app-kontable>

<p-dialog
        *ngIf="showDetail"
        [(visible)]="showDetail"
        [modal]="true"
        header="{{modalTitle}}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
  <app-application-form
          (applicationAdded)="applicationAdded($event)"
          (applicationUpdated)="applicationUpdated($event)"
          [dialogBoxItem]="selectedApplication"
  ></app-application-form>
</p-dialog>

<p-dialog
  *ngIf="showAssociateDialog"
  [(visible)]="showAssociateDialog"
  [modal]="true"
  header="{{'common.manageAssociations' | translate}} - {{application.name}}"
  [positionTop]="50"
  [minWidth]="700"
  [draggable]="false"
  [resizable]="false"
  (onHide)="showAssociateDialog=false">
  <app-associations origin="applications"></app-associations>
</p-dialog>




// WEBPACK FOOTER //
// ./src/app/views/administration/application/applications.component.html